/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-12 16:48:44
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-02 15:06:57
 */
import React from 'react';
import CustomModal from '../../components/CustomModal';
import closeimg from './img/icon-close.png'
import store from '../../../store'
import axios from 'axios'
import { connect } from 'react-redux';
import { Button, Input, message, Select, Modal, Radio } from 'antd';
import {
    check02, check35, checkMandt, issueFile, uploadPublicCd, setDbState, setDbIssue, setDbUploadOrder,
    multipleUpload, prodDocumentUpload
} from './service/action';
import {
    DateBaseTypeList,
    BasicGeoType,
    ExperimentalType,
    RemoteSensingFeatureType,
    InformationProductsType,
    ModelAlgorithmType,
    DataProductType,
    InterfaceComparison,
    DataService
} from './service/dataSetting.js'

const { Option } = Select;
const { TextArea } = Input;
const typeList = ['资料文档', '0-2级数据', '3-5级产品', '算法模型', '软件工具', '其他', '遥感特征数据']
const type02 = [{
    value: '光学卫星数据',
    label: '光学卫星数据',
}, {
    value: 'SAR影像数据',
    label: 'SAR影像数据',
}, {
    value: '电磁卫星数据',
    label: '电磁卫星数据',
}]

const typeName02 = [{
    value: 'GF1B',
    label: 'GF1B',
}, {
    value: 'GF1C',
    label: 'GF1C',
}, {
    value: 'GF1D',
    label: 'GF1D',
}, {
    value: 'ZY302',
    label: 'ZY302',
}, {
    value: 'SJ9A',
    label: 'SJ9A',
}]

const type35 = [{
    value: '3级五层十五级标准产品',
    label: '3级五层十五级标准产品',
}, {
    value: '4级五层十五级标准产品',
    label: '4级五层十五级标准产品',
}, {
    value: '5级五层十五级标准产品',
    label: '5级五层十五级标准产品',
}]

const typeYG = [{
    value: '土壤遥感光谱特征数据',
    label: '土壤遥感光谱特征数据',
}, {
    value: '岩矿遥感光谱特征数据',
    label: '岩矿遥感光谱特征数据',
}, {
    value: '植被遥感特征光谱数据',
    label: '植被遥感特征光谱数据',
}, {
    value: '植被遥感特征光谱数据',
    label: '植被遥感特征光谱数据',
}, {
    value: '城市目标遥感光谱特征数据',
    label: '城市目标遥感光谱特征数据',
}, {
    value: '地表大气遥感光谱特征数据',
    label: '地表大气遥感光谱特征数据',
}, {
    value: '水体遥感光谱特征数据',
    label: '水体遥感光谱特征数据',
}]

class PublishModal extends React.Component {
    state = {
        type: 0,
        file: {},
        title: '',
        // summary:''
        satellite_type: [],//当前选中的卫星种类
        satellite_name: [],//当前选中的卫星名称
        radiovalue: 1,//记录被选择的那个单选框的值
        visible: false,
        confirmLoading: false,
        fileName: '',
        isPublic: 1,

        DbInputName: "",
        DbInputType: "",
        DbInputSummaryOrNote: "",
        DocTitleValue: '',//文档标题
        DocKeywordValue: '',//文档关键词
        DocAbsValue: '',//文档摘要
        SelectTypeValue: '',//文档描述
    }

    componentWillMount() {
        if (this.props.publishModalOnRef) this.props.publishModalOnRef(this);
    }

    componentDidMount() {
        // this.main.show()
    }

    show = (file) => {
        // debugger
        // TODO:file路径
        let resourceUrl = file.resourcePath;
        // let region = /caplos.aircas.ac.cn\/\/?oss/;
        let newResource = resourceUrl.replace("https://caplos.aircas.ac.cn/cdoss/cdoss", "https://" + global.cloudDiskUrl);
        file.resourcePath = newResource;
        this.setState({ file: file, title: file.name, fileName: file.name })
        this.main.show()
    }
    typeSelect = (type) => {
        this.setState({ type: type })
    }
    issue = async () => {
        let { file } = this.state
        let res = await issueFile(file)
        message.info(res.message)
        this.main.close()
    }

    radioValueChange = (e) => {
        // console.log(e.target.value)
        this.setState({
            radiovalue: e.target.value
        })
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    };
    handleOk = async () => {
        const { file, DbInputName, DbInputType, DbInputSummaryOrNote } = this.state;
        const { user, zd_user } = this.props;
        let { name, id } = this.state.file

        let resourceType = ''
        if (this.state.isPublic === 1) {
            resourceType = typeList[this.state.type]
        } else {
            resourceType = DateBaseTypeList[this.state.type]
        }

        let userName = user.userName;
        let flag
        try {
            this.setState({
                confirmLoading: true
            })
            console.log(this.state.isPublic)
            if (this.state.isPublic === 1) {
                let res = await uploadPublicCd(name, id, resourceType, userName)
                alert(res)
                this.setState({
                    confirmLoading: false,
                    visible: false
                })
                this.props.reloadTable()
                this.main.close()
            } else {
                switch (resourceType) {
                    case '0-2级数据':
                        flag = await check02(this.state.file.resourcePath)
                        break;
                    case '3-5级数据':
                        flag = await check35(this.state.file.resourcePath)
                        break;
                    case '算法模型':
                        flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '处理工具':
                        flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '数据产品':
                        flag = await check02(this.state.file.resourcePath)
                        break;
                    case '信息产品数据':
                        flag = await check35(this.state.file.resourcePath)
                        break;
                    case '模型算法':
                        flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '资料文档':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '信息服务数据':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '基础地理参考数据':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '实验验证数据':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '遥感应用特征数据':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    case '遥感应用特征数据':
                        flag = '200'
                        // flag = await checkMandt(this.state.file.resourcePath)
                        break;
                    default:
                        alert('请选择正确文件类型')
                        this.setState({
                            confirmLoading: false,
                        })
                        break;
                }
                if (flag === '200') {
                    // let res = await setDbState(id)
                    console.log("this.props.user", this.props.user, id, this.state.file.resourcePath);
                    console.log(this.state.file)
                    let params = {}
                    console.log(this.state.SelectTypeValue)
                    let interfaceType = InterfaceComparison[this.state.SelectTypeValue]
                    console.log(interfaceType)
                    let oldResourcePath = this.state.file.resourcePath;
                    console.log("外网资源地址：", oldResourcePath);
                    let newResourcePath = oldResourcePath.repeat('', '');
                    if (interfaceType === 'prodDocumentUpload') {
                        params = {
                            'cdid': id,
                            'abs': this.state.DocAbsValue,
                            'description': this.state.DbInputSummaryOrNote,
                            'fileName': this.state.file.name,
                            'fileSize': this.state.file.size,
                            'keyword': this.state.DocKeywordValue,
                            'orderCacheAddr': this.state.file.resourcePath,
                            'orderCreationUserId': user.userId,
                            'productName': this.state.file.name,
                            'resourceType': this.state.SelectTypeValue,
                            'title': this.state.DocTitleValue
                        }
                    } else if (interfaceType === 'vectorUpload') {
                        params = {
                            'cdid': id,
                            "fileName": this.state.file.name,
                            "fileSize": this.state.file.size,
                            "orderCacheAddr": this.state.file.resourcePath,
                            "orderCreationUserId": user.userId,
                            "productName": this.state.file.name,
                            "resourceType": this.state.SelectTypeValue
                        }
                    } else {
                        params = {
                            'cdid': id,
                            "fileName": this.state.file.name,
                            "fileSize": this.state.file.size,
                            "orderCacheAddr": this.state.file.resourcePath,
                            "orderCreationUserId": user.userId,
                            "resourceType": this.state.SelectTypeValue
                        }
                    }
                    // let params = {
                    //     "fileName": this.state.file.name,
                    //     "fileSize": this.state.file.size,
                    //     "orderCacheAddr": this.state.file.resourcePath,
                    //     // "orderCreationTime": "2023-02-03T07:02:53.846Z",
                    //     "orderCreationUserId": user.userId,
                    //     // "orderId": "string",
                    //     // "orderIdUpload": "string",
                    //     // "orderStatus": "string",
                    //     "resourceType": resourceType,
                    //     "statusDescribe": this.state.DbInputSummaryOrNote,
                    //     // "statusUpdateTime": "2023-02-03T07:02:53.846Z"
                    // }
                    // let res2 = await setDbIssue(params);
                    // // debugger
                    // if (res2.code !== "200") message.error(res2.msg);
                    axios({
                        method: 'post',
                        url: global.url.order + `/order/issue/${interfaceType}`,
                        data: params
                    }).then((res) => {
                        if (res.data.code !== "200") {
                            message.error(res.data.message);
                            return;
                        }
                        ;
                        message.success("共享订单下达成功！");
                        // message.success("共享订单下达成功，等待入库……");
                        // let res2 = res.data.payload;
                        // console.log("setDbIssue", res2);
                        // let params2 = {
                        //     "datasize": res2.fileSize,
                        //     "dbstoreTime": res2.orderCreationTime,
                        //     "ip": "127.0.0.1",
                        //     "orderCacheAddr": res2.orderCacheAddr,
                        //     "orderCode": res2.orderId,
                        //     "orderDetails": "暂无",
                        //     // "orderStatus": res2.orderStatus,
                        //     "orderStatus": 0,
                        //     "orderStoreProCess": "",
                        //     "orderType": "个人云盘入库",
                        //     "ordersource": "共性产品检验与服务",
                        //     "time": res2.statusUpdateTime,
                        //     "userID": user.userId
                        // }
                        // console.log("res2----params2", res2, params2,);
                        // // let res3 = await setDbUploadOrder(params2);
                        // // if (res3.code !== 200) message.error(res2.msg);
                        // axios({
                        //     method: 'post',
                        //     // url: global.yunguanUploadOrder + '/managedeal/scdd/detailreceive',
                        //     url: '/yunguanUploadOrder/managedeal/scdd/detailreceive',
                        //     data: params2
                        // }).then((res) => {
                        //     if (res.data.code !== 0) { message.error(res.data.msg); return; }
                        //     let res3 = res.data;
                        //     console.log("setDbUploadOrder", res3)
                        //     this.setState({
                        //         confirmLoading: false,
                        //         visible: false
                        //     })
                        //     this.props.reloadTable()
                        //     this.main.close()
                        // }).catch((e) => {
                        //     message.error("上传订单失败！");
                        //     console.log(e)
                        //     this.setState({
                        //         confirmLoading: false,
                        //         visible: false
                        //     })
                        //     this.props.reloadTable()
                        //     this.main.close()
                        // })
                        this.setState({
                            type: 0,
                            file: {},
                            title: '',
                            // summary:''
                            satellite_type: [],//当前选中的卫星种类
                            satellite_name: [],//当前选中的卫星名称
                            radiovalue: 1,//记录被选择的那个单选框的值
                            visible: false,
                            confirmLoading: false,
                            fileName: '',
                            isPublic: 1,

                            DbInputName: "",
                            DbInputType: "",
                            DbInputSummaryOrNote: "",
                            DocTitleValue: '',//文档标题
                            DocKeywordValue: '',//文档关键词
                            DocAbsValue: '',//文档摘要
                            SelectTypeValue: '',//文档描述
                        })
                        this.main.close()
                    }).catch((e) => {
                        message.error("上传共享订单失败！");
                        console.log(e);
                        this.setState({
                            confirmLoading: false,

                        })
                    })
                    // let blobFile = this.getblobFile({ name: file.name, url: file.resourcePath });
                    // let urlFile = this.getPathToFile({ name: file.name, url: file.resourcePath });

                    // console.log("blobFile--urlFile", blobFile, urlFile,file);
                    // let sendParams = {
                    //     file: blobFile, resourceType, user, zd_user, DbInputName, DbInputType, DbInputSummaryOrNote
                    // }
                    // this.uploadToZDDatabase(sendParams);
                }
            }
        } catch (error) {
            this.setState({
                confirmLoading: false,
            })
            alert(error)
            console.log(error)
        }
    }

    /* 入库浙大数据库 */
    // uploadToZDDatabase = async (params) => {
    //     switch (params.resourceType) {
    //         case '0-2级数据':
    //             await check02(params)
    //             break;
    //         case '3-5级数据':
    //             await check35(params)
    //             break;
    //         case '算法模型':
    //             await checkMandt(params)
    //             break;
    //         case '处理工具':
    //             await checkMandt(params)
    //             break;
    //         case '资料文档':
    //             await prodDocumentUpload(params)
    //             break;
    //         default:
    //             alert('请选择正确文件类型')
    //             this.setState({
    //                 confirmLoading: false,
    //             })
    //             break;
    //     }
    // }
    /* -------------- */
    //将url文件转化成file文件
    getblobFile = async (data) => {
        let file = {};
        const response = await axios.get(data.url,);
        console.log("getblobFile---response", response);
        file = new window.File([response.data], data.name);


        // var content = JSON.stringify(data);
        // var blob = new Blob([content], { type: "text/plain;charset=utf-8" }); // 把数据转化成blob对象
        // // console.log(blob, "blob");
        // let file = new File([blob], "filename", { lastModified: Date.now() });
        return file
    };
    //
    getPathToFile = async (data) => {
        const response = await axios.get(data.url,);
        console.log("getPathToFile---response", response);
    };

    handleCancel = () => {
        this.setState({
            visible: false
        })
    };

    onChange = e => {
        this.setState({
            isPublic: e.target.value,
            type: 0
        })
    }

    /* 临时分类入库时的额外输入 */
    changeDbInputName = (data) => {
        console.log("changeDbInputName", data);
        this.setState({ DbInputName: data });
    }
    changeDbInputType = (data) => {
        console.log("changeDbInputType", data);
        this.setState({ DbInputType: data });
    }
    //文档摘要
    changeDbInputSummaryOrNote = (data) => {
        console.log("changeDbInputSummaryOrNote", data);
        this.setState({ DbInputSummaryOrNote: data });
    }
    //文档标题
    changeDocTitleValue = (data) => {
        console.log("changeDocTitleValue", data);
        this.setState({ DocTitleValue: data })
    }
    //文档摘要
    changeDocAbsValue = (data) => {
        console.log("changeDocTitleValue", data);
        this.setState({ DocAbsValue: data })
    }
    //文档关键字
    changeDocKeywordValue = (data) => {
        console.log("changeDocTitleValue", data);
        this.setState({ DocKeywordValue: data })
    }
    /* ------------ */

    //select框中数据变化
    changeSelectValue = (data) => {
        console.log('changeBasicGeoType', data)
        this.setState({ SelectTypeValue: data })
    }
    uploadToDatabase = () => {
        return (
            <>
                <div className="clouddisk-publish-modal-typeselect-wrap">
                    <div className="clouddisk-publish-modal-typeselect-title">数据类别</div>
                    <div className='clouddisk-publish-modal-typeselect'>
                        <div onClick={this.typeSelect.bind(this, 0)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 0 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '160px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '120px' }}>基础地理参考数据
                            </div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 1)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 1 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '120px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '85px' }}>实验验证数据
                            </div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 2)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 2 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '160px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '120px' }}>遥感应用特征数据
                            </div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 3)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 3 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '120px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '85px' }}>信息产品数据
                            </div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 4)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 4 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-middle' :
                                ' clouddisk-publish-modal-typeselect-btn-middle'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-middle">模型算法</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 5)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 5 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-middle' :
                                ' clouddisk-publish-modal-typeselect-btn-middle'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-middle">数据产品</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 6)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 6 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '120px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '85px' }}>信息服务数据
                            </div>
                        </div>
                    </div>
                </div>
                <div className='clouddisk-publish-modal-typedetail-content'>
                    {
                        this.state.type !== 6 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>数据类型</div>
                                <Select
                                    style={{ width: '388px' }}
                                    options={
                                        this.state.type === 0 ? BasicGeoType :
                                            this.state.type === 1 ? ExperimentalType :
                                                this.state.type === 2 ? RemoteSensingFeatureType :
                                                    this.state.type === 3 ? InformationProductsType :
                                                        this.state.type === 4 ? ModelAlgorithmType :
                                                            DataProductType
                                    }
                                    onChange={(e) => this.changeSelectValue(e)}
                                ></Select>
                            </div>
                        </> : <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>数据类型</div>
                                {/* <div className="clouddisk-publish-modal-typedetail-type">文档数据</div> */}
                                <Select
                                    style={{ width: '388px' }}
                                    options={DataService}
                                    onChange={(e) => this.changeSelectValue(e)}
                                ></Select>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>标题</div>
                                <Input style={{ width: '388px' }}
                                    onChange={(e) => this.changeDocTitleValue(e.target.value)}></Input>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>关键字</div>
                                <Input style={{ width: '388px' }}
                                    onChange={(e) => this.changeDocKeywordValue(e.target.value)}></Input>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>摘要</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}
                                    onChange={(e) => this.changeDocAbsValue(e.target.value)}></TextArea>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>文档描述</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}
                                    onChange={(e) => this.changeDbInputSummaryOrNote(e.target.value)}></TextArea>
                            </div>
                        </>
                    }
                </div>
            </>
        )
    }

    uploadToPublicCloud = () => {
        return (
            <>
                <div className="clouddisk-publish-modal-typeselect-wrap">
                    <div className="clouddisk-publish-modal-typeselect-title">数据类型</div>
                    <div className='clouddisk-publish-modal-typeselect'>
                        <div onClick={this.typeSelect.bind(this, 0)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 0 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-long">资料文档</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 1)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 1 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-long">0-2级数据</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 2)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 2 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-long">3-5级产品</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 3)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 3 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-middle' :
                                ' clouddisk-publish-modal-typeselect-btn-middle'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-middle">算法模型</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 4)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 4 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-middle' :
                                ' clouddisk-publish-modal-typeselect-btn-middle'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text-middle">软件工具</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 5)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 5 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-shot' :
                                ' clouddisk-publish-modal-typeselect-btn-shot'}`}>
                            <div className="clouddisk-publish-modal-typeselect-text">其他</div>
                        </div>
                        <div onClick={this.typeSelect.bind(this, 6)}
                            className={`clouddisk-publish-modal-typeselect-btn${this.state.type === 6 ?
                                ' clouddisk-publish-modal-typeselect-btn-checked-long' :
                                ' clouddisk-publish-modal-typeselect-btn-long'}`} style={{ width: '120px' }}>
                            <div className="clouddisk-publish-modal-typeselect-text-long"
                                style={{ width: '85px' }}>遥感特征数据
                            </div>
                        </div>
                    </div>
                </div>
                <div className='clouddisk-publish-modal-typedetail-content'>
                    {
                        this.state.type === 0 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>标题</div>
                                <Input style={{ width: '388px' }}></Input>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>摘要</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : this.state.type === 1 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>卫星种类</div>
                                <Select style={{ width: '388px' }} options={type02}></Select>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>卫星名称</div>
                                <Select style={{ width: '388px' }} options={typeName02}></Select>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : this.state.type === 2 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>卫星种类</div>
                                <Select key={1} style={{ width: '388px' }} options={type35}
                                    defaultValue={'3级五层十五级标准产品'}></Select>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : this.state.type === 3 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>算法名称</div>
                                <Input style={{ width: '388px' }}></Input>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : this.state.type === 4 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>工具类型</div>
                                <Input style={{ width: '388px' }}></Input>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : this.state.type === 5 ? <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </> : <>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>产品种类</div>
                                <Select key={2} style={{ width: '388px' }} options={typeYG}
                                    defaultValue={'土壤遥感光谱特征数据'}></Select>
                            </div>
                            <div className='clouddisk-publish-modal-typedetail-cell'>
                                <div className='clouddisk-publish-modal-typedetail-title'>备注</div>
                                <TextArea rows={4} autoSize={false} style={{ width: '388px' }}></TextArea>
                            </div>
                        </>
                    }
                </div>
            </>
        )
    }

    render() {
        // console.log("zd_user", this.props.zd_user);
        return (<CustomModal ref={ref => this.main = ref}>
            <div className='clouddisk-publish-modal'>
                <div className={'clouddisk-publish-modal-title modal-dragable'}>
                    {'发布至'}
                    <img alt='' src={closeimg} className={'clouddisk-publish-modal-closeimg'}
                        onClick={() => this.main.close()}></img>
                </div>
                <div className="clouddisk-publish-modal-typeselect-wrap">
                    <div className="clouddisk-publish-modal-typeselect-title">文件名</div>
                    <Input
                        className="clouddisk-publish-modal-infopanel-input"
                        placeholder="请输入发布的文件命名"
                        onChange={(e) => this.setState({ fileName: e.target.value })}
                        value={this.state.file.name}
                    ></Input>
                </div>
                <div className="clouddisk-publish-modal-typeselect-wrap">
                    <div className="clouddisk-publish-modal-typeselect-title" style={{ lineHeight: '9px' }}>发布去向</div>
                    <Radio.Group onChange={this.onChange} value={this.state.isPublic}>
                        <Radio value={1}>公共云盘</Radio>
                        <Radio value={2}>库</Radio>
                    </Radio.Group>
                </div>
                {
                    this.state.isPublic === 1 ?
                        this.uploadToPublicCloud() :
                        this.uploadToDatabase()
                }
                <div className='clouddisk-publish-modal-bottombar'>
                    <Button className='clouddisk-publish-modal-cancel' onClick={() => this.main.close()}> 取消</Button>
                    <Button className='clouddisk-publish-modal-publish' onClick={this.showModal}> 发布</Button>
                </div>
            </div>
            <Modal
                title="确认文件信息(确认文件类型后缀无误)"
                visible={this.state.visible}
                onOk={this.handleOk}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
            >
                <p>文件名为：{this.state.fileName}</p>
                {
                    this.state.isPublic === 1 ? <p>文件类别为：{typeList[this.state.type]}</p> :
                        <p>文件类别为：{DateBaseTypeList[this.state.type]}</p>
                }

            </Modal>
        </CustomModal>)
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
export default connect(mapState, mapDispatch)(PublishModal);
